import { Page } from "@/models/page-models/Page";

export const FactoryTicketEdit: Page = {
  "path": "factory-ticket/:factoryTicketId",
  "name": "Factory Ticket",
  "props": {
    "data": {
      "title": "Factory Ticket",
      "printable": "TRUE",
      "url": "factory-ticket/:factoryTicketId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.selectedOrderNo",
                  "label": "Select Order",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copySelectedOrderData"
                    },
                    {
                      "executionOrder": 2,
                      "name": "copyPackingModeFilterFlag"
                    },
                    {
                      "executionOrder": 3,
                      "name": "getFilteredProcesses"
                    }
                  ],
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copyOrderNo"
                    },
                    {
                      "executionOrder": 1,
                      "name": "copySelectedOrderData"
                    },
                    {
                      "executionOrder": 2,
                      "name": "copyPackingModeFilterFlag"
                    },
                    {
                      "executionOrder": 3,
                      "name": "getFilteredProcesses"
                    }
                  ],
                  "disabled": "TRUE",
                  "items": "fetchedData.orders",
                  "itemText": "productLine",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,orderDescription,{{__item}})",
                  "printable": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "custom_FtOrderDetails",
                  "variable": "formData.selectedOrderDetails",
                  "disabled": "FALSE",
                  "showIf": "{{formData.selectedOrderDetails}}",
                  "config": {
                    "totalQuantityProducedVariable": "fetchedData.balanceQuantity.data.totalQuantityProduced"
                  }
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_FtProcesses",
                  "variable": "formData.processes",
                  "label": "Processes",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket.order}}",
                  "items": "formData.processes",
                  "config": {
                    "orderDetailsVariable": "formData.selectedOrderDetails",
                    "formVariable": "formData.factoryTicket",
                    "rmVariable": "fetchedData.goods.data",
                    "fixedWidth": true
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Add Process",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "openProcessPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{{{formData.selectedOrderDetails}} && fn(MATCH_ROLE,Production | Planner)}}",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Add New Process",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedProcess",
                  "label": "Select Process",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "getMachinesForProcess"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredProcesses",
                  "itemText": "name",
                  "itemValue": "name",
                  "required": true
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedMachine",
                  "label": "Select Machine",
                  "disabled": "FALSE",
                  "items": "fetchedData.selectedMachines",
                  "itemText": "name",
                  "itemValue": "_id",
                  "required": true
                }
              ]
            }
          ],
          "width": "500",
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "copySelectedMachineData"
                },
                {
                  "executionOrder": 2,
                  "name": "addProcess"
                },
                {
                  "executionOrder": 3,
                  "name": "closeProcessPopup",
                  "event": "addProcessToFactoryTicket",
                  "eventDataVariable": "fetchedData.processes"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "saveFactoryTicket"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(MATCH_ROLE,Production | Planner)",
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "color": "secondary",
                  "buttonType": "print"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getAllMachines"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllProcesses",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=processes",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.allProcesses"
        },
        "name": "getAllProcesses"
      },
      {
        "executionOrder": 2,
        "name": "getFactoryTicketData"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getBalanceQuantity",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/order/{{formData.selectedOrderNo}}/balance-quantity",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.balanceQuantity"
        }
      }
    ],
    "functions": [
      {
        "name": "getFactoryTicketData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/factoryticket/get?id={{__params.factoryTicketId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "formData",
        "arg3Key": "sourceTransformationFn",
        "arg3Value": "transformFactoryTicketData",
        "arg4Key": "fnsAfterSubmit",
        "arg4Value": "pushOrderDetails"
      },
      {
        "name": "transformFactoryTicketData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "factoryTicket": "__selectedObject.data.0",
          "selectedOrderNo": "__selectedObject.data.0.order._id",
          "selectedOrderDetails": "__selectedObject.data.0.order"
        }
      },
      {
        "name": "pushOrderDetails",
        "type": "fnPushToArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "formData.selectedOrderDetails",
        "arg2Key": "destinationVariable",
        "arg2Value": "fetchedData.orders"
      },
      {
        "name": "copyOrderNo",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "formData.selectedOrderNo",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.factoryTicket.order"
      },
      {
        "name": "getAllMachines",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/machines/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.machines"
      },
      {
        "name": "copySelectedOrderData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.selectedOrderDetails",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object"
      },
      {
        "name": "copyPackingModeFilterFlag",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getPackingFlag",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getPackingFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "enablePacking": "fn(CONDITIONAL,fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,{{__arrayItem.quantity}},!==,0),{{formData.selectedOrderDetails.product.packingMode}},unit1),!==,fn(LENGTH,{{formData.selectedOrderDetails.product.packingMode}})),Packing,'')"
        },
        "useFormula": true
      },
      {
        "name": "getFilteredProcesses",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterProcesses",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.filteredProcesses"
      },
      {
        "name": "filterProcesses",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.allProcesses.data.0.data",
        "arg2Key": "searchKey",
        "arg2Value": "name",
        "arg3Key": "searchValue",
        "arg3Value": "{{fetchedData.enablePacking}}",
        "arg4Key": "filterCondition",
        "arg4Value": "!=="
      },
      {
        "name": "openProcessPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Add New Process"
      },
      {
        "name": "closeProcessPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Add New Process"
      },
      {
        "name": "filterPossibleMachinesForProcess",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.machines.data",
        "arg2Key": "searchKey",
        "arg2Value": "possibleProcesses",
        "arg3Key": "searchValue",
        "arg3Value": "{{fetchedData.selectedProcess}}",
        "arg4Key": "searchKeyValueType",
        "arg4Value": "Array"
      },
      {
        "name": "getMachinesForProcess",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterPossibleMachinesForProcess",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedMachines"
      },
      {
        "name": "addProcess",
        "type": "fnPushToArray",
        "arg1Key": "sourceFn",
        "arg1Value": "createInitialProcessData",
        "arg2Key": "destinationVariable",
        "arg2Value": "fetchedData.processes"
      },
      {
        "name": "getSelectedMachineData",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.machines.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedMachine"
      },
      {
        "name": "copySelectedMachineData",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getSelectedMachineData",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedMachineData"
      },
      {
        "name": "createInitialProcessData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "fetchedData.selectedProcess",
          "machine": "fetchedData.selectedMachineData.name",
          "machineDetail": "fetchedData.selectedMachineData"
        }
      },
      {
        "name": "saveFactoryTicket",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/factoryticket/save",
        "arg2Key": "postData",
        "arg2Value": "formData.factoryTicket",
        "arg3Key": "storeResponse",
        "arg3Value": "TRUE",
        "arg4Key": "refreshPage",
        "arg4Value": "TRUE"
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER,PRODUCTION_PLANNER",
  "visible": false
}